import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import ApiRequest from '../../Decorators/ApiRequest';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';
import { FetchStoreByCoordinatesArgs } from './Interfaces/FetchStoreByCoordinatesArgs';

const BASE_URL_PURCHASE = import.meta.env.VITE_BASE_URL_PURCHASE;

export class SetStoreByCoordinatesGateway {
    async sendCurrentAddress(
        longitude: string,
        latitude: string
    ): Promise<ApiResult<any>> {
        const body: FetchStoreByCoordinatesArgs = {
            action: 'setStoreByCoordinates',
            longitude: longitude,
            latitude: latitude,
        };
        try {
            const response = await ApiRequest(`${BASE_URL_PURCHASE}`, {
                method: 'POST',
                headers: API_DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });

            if (response.status !== 200 && response.status !== 201) {
                console.error(response.statusText ?? 'Failed to update store');
                return {
                    error: true,
                    message: 'Failed to update store',
                };
            }
            return { error: false };
        } catch (error) {
            return {
                error: true,
                message: 'Failed to update store',
            };
        }
    }
}
